import { combineReducers } from 'redux';
import components from './components';
import routes from './routes';
import relatedGuests from './related-guests';
import note from './note';
import auditLog from './audit-log';
import file from './file';
import visit from './visit';
import userRoleOptions from './user-role-options';
import userLocationOptions from './user-location-options';
import associatedDomainOptions from './associated-domain-options';
import associationLinkOptions from './association-link-options';
import reservation from './reservation';

export default combineReducers({
  components,
  routes,
  relatedGuests,
  note,
  auditLog,
  file,
  visit,
  userRoleOptions,
  userLocationOptions,
  associatedDomainOptions,
  associationLinkOptions,
  reservation
});
